/* US/EU size scale toggle. Both scales are rendered in Liquid; this only flips <html data-size-scale>,
   which CSS reads, so variant values are never touched. US is the default on every page load. */
(function () {
  if (window.SizeConverterReady) return;
  window.SizeConverterReady = true;

  var root = document.documentElement;

  function currentScale() {
    return root.getAttribute('data-size-scale') === 'eu' ? 'eu' : 'us';
  }

  function syncButtons() {
    var scale = currentScale();
    document.querySelectorAll('[data-size-converter] [data-size-scale]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-size-scale') === scale ? 'true' : 'false');
    });
  }

  function setScale(scale) {
    if (scale === 'eu') {
      root.setAttribute('data-size-scale', 'eu');
    } else {
      root.removeAttribute('data-size-scale');
    }
    syncButtons();
  }

  /* Delegated once at document level, so re-rendered sections in the theme editor need no rebinding */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-size-converter] [data-size-scale]');
    if (button) setScale(button.getAttribute('data-size-scale'));
  });

  document.addEventListener('shopify:section:load', syncButtons);
})();
